import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SvgScriptLoaderService {
  //Service to load and remove javascript files dynamically
  loadScript(src: string): Promise<HTMLScriptElement> {
    return new Promise((resolve, reject) => {
      let script = document.querySelector(`script[src="${src}"]`) as HTMLScriptElement;

      if (!script) {
        script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.onload = () => resolve(script);
        script.onerror = () => reject(new Error(`Script load error for ${src}`));
        document.body.appendChild(script);
      } else {
        resolve(script);
      }
    });
  }

  removeScript(src: string): void {
    const script = document.querySelector(`script[src="${src}"]`);
    if (script) {
      document.body.removeChild(script);
    }
  }
}
